import { useEffect, useState } from "react";
import { useTheme } from "@mui/material";

const ON = "on";
const OFF = "off";
const DISABLED = "disabled";
export type TMode = typeof ON | typeof OFF | typeof DISABLED;

const useModeColor = (mode: TMode) => {
  const { palette } = useTheme();
  const [color, setColor] = useState(palette.primary.main);
  useEffect(() => {
    if (mode === ON) {
      setColor(palette.on.contrastText);
    } else if (mode === OFF) {
      setColor(palette.off.contrastText);
    } else {
      setColor(palette.disabled.contrastText);
    }
  }, [
    mode,
    palette.on.contrastText,
    palette.off.contrastText,
    palette.disabled.contrastText,
  ]);
  return color;
};

export default useModeColor;
